export enum RequestType {
    ASSET = 'asset',
    REST = 'restful',
    BSOI = 'bsoi',
}
